/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import FieldDetailsModal from "./FieldDetails";
import {
  ADDED,
  SELECTED,
  SHAREDFIELD,
  LOGERROR,
  DANGER,
  SHARED_FIELDS,
  INFO,
  FIELDS,
  CROPS,
  EMPTY,
  DISPLAY_FIELD_OPTIONS,
} from "../../configurations/Constants";
import { Accordion, Card, Form, Col, Row } from "react-bootstrap";
import GoogleMapHelper from "../../helpers/GoogleMapHelper";
import SessionHelper from "../../helpers/SessionHelper";
import UserService from "../../api-service/UserService";
import ShareFieldPopUp from "../fieldDetails/FieldSharePopUp";
import DeletePopUp from "../wdpMap/DeleteShareFieldPopUp";
import ShareFieldService from "../../api-service/ShareFieldService";
import FluentdHelper from "../../helpers/FluentdHelper";
import Alert from "../common/Alert";
import _ from "lodash";
import { useSelector } from "react-redux";
import {
  DELETE_OR_REJECT_ACCESS_TO_SHARE_FIELD,
  SHARED_FIELD_REJECTED_SUCCESSFULLY,
  SHARED_FIELD_DELETED_SUCCESSFULLY,
  ERROR_FETCHING_FIELD_DETAILS,
  ERROR_WHILE_UPDATING_FIELD,
} from "../../configurations/MessageConstants";
import LoadingOverlay from "../common/LoadingOverlay";
import { StatusCodes } from "../../configurations/status-codes";

function WDPPanel(props) {
  const AllPolygons = useSelector((state) => state.field.allPolygons);
  const UserCropDetails = useSelector((state) => state.field.userCropDetails);
  const loggedInUser = useSelector((state) => state.user.loggedInUser);
  const FarmsValue = useSelector((state) => state.field.farms);
  const BusinessValue = useSelector((state) => state.field.business);

  const [userRegisteredFields, setUserRegisteredFields] = useState({});
  const [userClaimedFields, setUserClaimedFields] = useState({});
  const [userSharedFields, setUserSharedFields] = useState({});
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [irrig_unit_Id, setIrrig_unit_Id] = useState(EMPTY);
  const [header, setHeader] = useState(EMPTY);
  const [fieldId, setFieldId] = useState(EMPTY);
  const [showFieldPopup, setShowFieldPopup] = useState(false);
  const [fieldCrops, setFieldCrops] = useState([]);
  const [fieldAcres, setFieldAcres] = useState(EMPTY);
  const [selectedField, setSelectedField] = useState(EMPTY);
  const [fieldDetails, setFieldDetails] = useState({});
  const [fieldNames, setFieldNames] = useState([]);
  const [displayAllField, setDisplayAllField] = useState(true);
  // const [displayToggle, setDisplayToggle] = useState(true);
  const [businessFarmList, setBusinessFarmList] = useState([
    {
      businessName: EMPTY,
      businessId: EMPTY,
      isActive: false,
      farms: [
        {
          farmName: EMPTY,
          farmId: EMPTY,
          isActive: false,
        },
      ],
    },
  ]);
  const [sharedField, setSharedField] = useState(false);
  const [shareFieldDetails, setShareFieldDetails] = useState({});
  const [shareFieldPopUp, setShareFieldPopUp] = useState(false);
  const [selectedFieldsOnPanel, setSelectedFieldsOnPanel] = useState([]);
  const [selectedIrrigUnitIds, setSelectedIrrigUnitIds] = useState([]);
  const [shareFieldId, setShareFieldId] = useState(EMPTY);
  const [alertMessage, setAlertMessage] = useState(EMPTY);
  const [variant, setVariant] = useState(EMPTY);
  const [submitError, setSubmitError] = useState(false);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [defaultModalActiveKey, setDefaultModalActiveKey] = useState(EMPTY);
  const [displayOptionsKey, setDisplayOptionsKey] = useState(
    DISPLAY_FIELD_OPTIONS
  );

  useEffect(() => {
    const userRegisteredFieldsValue = props.userRegisteredFields;
    const userSharedFieldsValue = props.userSharedField;
    const claimedFieldsValue = props.userClaimedFields;
    loadBusinessAndFarms();
    setUserRegisteredFields(userRegisteredFieldsValue);
    setUserClaimedFields(claimedFieldsValue);
    setUserSharedFields(userSharedFieldsValue);
  }, []);

  const handdlePanelButtonClick = async (
    sortedUsersField,
    fieldId,
    cropDetails,
    acres,
    irrig_unit_Id,
    selectedField,
    fieldDetails,
    fieldNames,
    sharedField,
    shareFieldDetails,
    defaultModalActiveKey
  ) => {
    await SessionHelper.handleRefreshToken();

    const coordinates = fieldDetails;
    const geomObject = getGeometry(coordinates);
    if (geomObject) {
      coordinates.geometry = geomObject.geometry;
    }
    const paths = GoogleMapHelper.getCoordinates(coordinates);
    const coords = GoogleMapHelper.getPolygonCenter(coordinates);
    coords.lng = coords.lng + 0.023;
    const fillColor1 = sharedField ? SHAREDFIELD : ADDED;
    const fillColor2 = SELECTED;
    props.showFieldOnMAP(coords, paths, irrig_unit_Id, fillColor1, fillColor2);
    setDefaultModalActiveKey(defaultModalActiveKey);
    setFieldAcres(acres);
    setFieldCrops(cropDetails);
    setFieldId(fieldId);
    setIrrig_unit_Id(irrig_unit_Id);
    setSelectedField(selectedField);
    setFieldDetails(fieldDetails);
    setFieldNames(fieldNames);
    setSharedField(sharedField);
    setShareFieldDetails(shareFieldDetails);
    setShowFieldPopup(true);
    props.field_edit(sortedUsersField, true);
  };

  const refreshPanel = async (value) => {
    const userRegisteredFieldsValue = await getUserFieldDetails();
    const allShared = userRegisteredFieldsValue.data.shared;
    const nonRejectedSharedfields = allShared.filter((field) => {
      return field.rejected === false;
    });
    userRegisteredFieldsValue.data.shared = nonRejectedSharedfields;
    loadBusinessAndFarms();
    setUserRegisteredFields(userRegisteredFieldsValue);
    setUserSharedFields(userRegisteredFieldsValue.data.shared);
    setShowFieldPopup(!value);
    filterFieldOnMap(businessFarmList, nonRejectedSharedfields);
  };

  const closeModal = () => {
    setShowFieldPopup(false);
  };

  const getUserFieldDetails = async () => {
    try {
      if (!loggedInUser) return {};
      const payload = {
        user_email: loggedInUser,
        keys: [FIELDS, CROPS, SHARED_FIELDS],
      };
      const response = await UserService.getUserFieldDetails(payload);
      const userRegisteredFieldsValue = response.data;
      return response.status === StatusCodes.OK
        ? userRegisteredFieldsValue
        : {};
    } catch (error) {
      console.error(ERROR_FETCHING_FIELD_DETAILS, error);
    }
  };

  const getCurrentYearAcres = (irrig_unit_id) => {
    let currentyear = new Date().getFullYear();
    let yearAcresDetails = props.yearAcresDetails;
    let isCurrentYearAcres = yearAcresDetails[irrig_unit_id];
    if (isCurrentYearAcres) {
      let currentYearAcresData = _.find(isCurrentYearAcres.tp_year_wise_data, {
        crop_year: currentyear,
      });
      if (currentYearAcresData) {
        let currentYearAcres = currentYearAcresData.acres;
        return currentYearAcres;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const handleDisplayAllField = (event) => {
    const status = !displayAllField;
    const newbusiness_details_withCount = businessFarmList.map(
      (business, sidx) => {
        return {
          ...business,
          isActive: status,
          farms: business.farms.map((farm) => {
            return { ...farm, isActive: status };
          }),
        };
      }
    );
    setDisplayAllField(status);
    setBusinessFarmList(newbusiness_details_withCount);
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    setSelectAll(false);

    if (status === true) {
      filterFieldOnMap(newbusiness_details_withCount, false);
    } else {
      filterFieldOnMap(newbusiness_details_withCount, false);
    }
    removeWells();
  };

  const toggleBusinessCheckbox = (idx) => (evt) => {
    const newbusiness_details = businessFarmList.map((business, sidx) => {
      if (idx !== sidx) return business;
      return { ...business, isActive: !business.isActive };
    });
    const newbusiness_details_withCount = newbusiness_details.map(
      (business, sidx) => {
        if (idx !== sidx) return business;
        return {
          ...business,
          farms: business.farms.map((farm) => {
            return { ...farm, isActive: business.isActive };
          }),
        };
      }
    );

    let allStatus =
      newbusiness_details_withCount.filter(
        (business) => business.isActive === false
      ).length > 0 &&
      newbusiness_details_withCount.filter(
        (business) =>
          business.farms.filter((farm) => farm.isActive === false).length > 0
      )
        ? false
        : true;

    setBusinessFarmList(newbusiness_details_withCount);
    setDisplayAllField(allStatus);
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    setSelectAll(false);

    filterFieldOnMap(newbusiness_details_withCount, false);
    removeWells();
  };

  const filterFieldOnMap = (list, sharedFields) => {
    let fields = userRegisteredFields.data.fields.concat(userSharedFields);
    let selectedBusiness = [];
    let selectedFarms = [];
    let irrig_unit_ids = [];
    let geometries = [];
    list.map((businessFarm) => {
      if (businessFarm.isActive) {
        selectedBusiness.push(businessFarm.businessName);
      }
      businessFarm.farms.map((farm) => {
        if (farm.isActive) {
          selectedFarms.push(farm.farmName);
        }
      });
    });
    if (fields && fields.length > 0) {
      for (let m = 0; m < fields.length; m++) {
        if (
          selectedBusiness.includes(fields[m].business_name) &&
          selectedFarms.includes(fields[m].farm_name)
        ) {
          irrig_unit_ids.push(fields[m].irrig_unit_id);
          geometries.push({
            geometry: fields[m].geometry,
          });
        }
      }
    }
    props.filterFieldsOnMap(irrig_unit_ids, geometries, sharedFields);
  };

  const toggleFarmCheckbox = (bidx, fidx) => (evt) => {
    const newbusiness_details = businessFarmList.map((business, sidx) => {
      if (bidx !== sidx) return business;
      return {
        ...business,
        farms: business.farms.map((farm, jidx) => {
          if (fidx !== jidx) return farm;
          return { ...farm, isActive: !farm.isActive };
        }),
      };
    });
    const newbusiness_details_withCount = newbusiness_details.map(
      (business, sidx) => {
        if (bidx !== sidx) return business;
        return {
          ...business,
          isActive:
            business.farms.filter((farm) => farm.isActive === true).length > 0
              ? true
              : false,
        };
      }
    );

    let allStatus =
      newbusiness_details_withCount.filter(
        (business) =>
          business.farms.filter((farm) => farm.isActive === false).length > 0
      ).length > 0
        ? false
        : true;

    setBusinessFarmList(newbusiness_details_withCount);
    setDisplayAllField(allStatus);
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    setSelectAll(false);

    filterFieldOnMap(newbusiness_details_withCount, false);
    removeWells();
  };

  const loadBusinessAndFarms = () => {
    let parser = new DOMParser();
    let businessList = BusinessValue;
    let farms = FarmsValue;
    let businesses = [];
    for (let i = 0; i < businessList.length; i++) {
      const businessNameDoc = parser.parseFromString(
        businessList[i],
        "text/html"
      );
      let farmsList = [];

      for (let j = 0; j < farms.length; j++) {
        const businessName = parser.parseFromString(
          farms[j].businessName,
          "text/html"
        );
        let farm = {};
        if (businessNameDoc.body.innerText === businessName.body.innerText) {
          const farmNameDoc = parser.parseFromString(
            farms[j].farmName,
            "text/html"
          );
          farm = {
            farmName: farmNameDoc.body.innerText,
            farmId: farmNameDoc.body.innerText,
            isActive: true,
          };
          farmsList.push(farm);
        }
      }

      let business = {
        businessName: businessNameDoc.body.innerText,
        businessId: businessNameDoc.body.innerText,
        isActive: true,
        farms: farmsList,
      };
      businesses.push(business);
    }
    setBusinessFarmList(businesses);
  };

  const expandAll = () => {
    props.expandAll();
  };

  const collapseAll = () => {
    props.collapseAll();
    setTimeout(() => {
      let cards = document.getElementsByClassName("field_card");
      for (let i = 0; i < cards.length; i++) {
        cards[i].classList.remove("show");
      }
    }, 0);
  };
  const removeWells = () => {
    props.removeWells();
  };

  const handleShareFields = async () => {
    await SessionHelper.handleRefreshToken();
    setShareFieldPopUp(true);
  };

  const handleFieldCheck = (
    selectedFieldData,
    shareFieldIrrigUnitId,
    shareUserFieldId,
    shareFieldName,
    shareFieldAcres,
    acresCurrentYear,
    shareFieldFarm,
    shareFieldBusiness,
    fieldSharedByUser,
    shareFieldEditor,
    is_primary_editing,
    secondary_user_id,
    user_email
  ) => {
    let selectedIrrigUnitIdsValue = selectedIrrigUnitIds;
    let selectedFields = selectedFieldsOnPanel;
    if (
      selectedFields.some(
        (field) => field.irrig_unit_id === shareFieldIrrigUnitId
      )
    ) {
      selectedFields = selectedFields.filter((field) => {
        return field.irrig_unit_id !== shareFieldIrrigUnitId;
      });
    } else {
      selectedFields.push({
        fieldData: selectedFieldData,
        irrig_unit_id: shareFieldIrrigUnitId,
        fieldId: shareUserFieldId,
        fieldName: shareFieldName,
        fieldAcres: shareFieldAcres,
        acresCurrentYear: acresCurrentYear,
        fieldFarm: shareFieldFarm,
        fieldBusiness: shareFieldBusiness,
        fieldSharedByOtherUser: fieldSharedByUser,
        shareFieldEditor: shareFieldEditor,
        is_primary_editing: is_primary_editing,
        secondary_user_id: secondary_user_id,
        user_email: user_email,
      });
    }
    if (
      selectedIrrigUnitIdsValue.some(
        (irrig_unit_id) => irrig_unit_id === shareFieldIrrigUnitId
      )
    ) {
      selectedIrrigUnitIdsValue = selectedIrrigUnitIdsValue.filter(
        (field_irrig_unit_id) => {
          return field_irrig_unit_id !== shareFieldIrrigUnitId;
        }
      );
    } else {
      selectedIrrigUnitIdsValue.push(shareFieldIrrigUnitId);
    }
    setSelectedFieldsOnPanel(selectedFields);
    setSelectedIrrigUnitIds(selectedIrrigUnitIdsValue);
    props.field_check(selectedFields, true);
  };
  const handleCloseShareModal = () => {
    setShareFieldPopUp(false);
  };

  const handleClearAllSelectedFields = () => {
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    setSelectAll(false);
  };

  const handleRejectOrDeleteShareFieldClick = (
    e,
    shareFieldId,
    selectedField
  ) => {
    setShowConfirmPopup(true);
    setHeader(DELETE_OR_REJECT_ACCESS_TO_SHARE_FIELD);
    setSelectedField(selectedField);
    setShareFieldId(shareFieldId);
  };

  const closeWarningPopup = () => {
    setShowConfirmPopup(false);
    setHeader(EMPTY);
    setShareFieldId(EMPTY);
  };

  const performWarningAction = async (e, idx) => {
    let id = shareFieldId;
    const user_email = loggedInUser;
    let payload = {};
    if (idx === 0) {
      payload = {
        shared_field_id: id,
        deleted: true,
      };
    } else if (idx === 1) {
      payload = {
        shared_field_id: id,
        rejected: true,
      };
    }

    try {
      await ShareFieldService.updateShareFieldDetails(payload);
      setShowConfirmPopup(false);
      setHeader(EMPTY);
      setAlertMessage(
        idx === 0
          ? SHARED_FIELD_DELETED_SUCCESSFULLY
          : SHARED_FIELD_REJECTED_SUCCESSFULLY
      );
      setVariant(INFO);
      setSubmitError(true);
      setShareFieldId(EMPTY);
      setOverlayLoading(true);

      await refreshPanel(true);
      const myDiv = document.getElementsByClassName(
        "farmer-panel-fields-accordion"
      );
      myDiv[0].scrollTop = 0;
      setOverlayLoading(false);
    } catch (error) {
      console.error(ERROR_WHILE_UPDATING_FIELD, error);
      handleCatchErrorLogs(
        error.response.data.message,
        "RejectField_performWarningAction",
        payload,
        error,
        user_email,
        error.response.status === StatusCodes.BAD_REQUEST ? false : true
      );
    }
  };

  const handleCatchErrorLogs = (
    errormessage,
    actionMethod,
    payload,
    e,
    user_email,
    sendFluentd
  ) => {
    setShowConfirmPopup(false);
    setHeader(EMPTY);
    setAlertMessage(errormessage);
    setVariant(DANGER);
    setSubmitError(true);
    setShareFieldId(EMPTY);

    if (sendFluentd === true) {
      FluentdHelper.logEvent(
        errormessage,
        actionMethod,
        user_email,
        {
          request: payload,
          response: e,
        },
        LOGERROR
      );
    }
  };

  const getValidatedYears = (sharedField) => {
    let seasonAllowed = [];
    if (sharedField) {
      let currentyear = new Date().getFullYear();
      let rowData = sharedField;
      let addedDate = new Date(rowData.added_on);
      let addedYear = addedDate.getFullYear();
      let removedOn = rowData.removed;
      let seasonChangeDate = new Date(`15/APR/${addedYear}`).getTime();
      let year = 0;
      let removedYear =
        removedOn !== null ? new Date(rowData.removed).getFullYear() : null;
      if (addedYear === removedYear && removedYear !== null) {
        year = addedYear;
        seasonAllowed.push(year.toString());
      } else if (addedYear !== removedYear && removedYear !== null) {
        for (let j = addedYear; j < removedYear; j++) {
          year = j;
          seasonAllowed.push(year.toString());
          year += 1;
          if (year === removedYear) {
            seasonChangeDate = new Date(`15/APR/${year}`).getTime();
            if (removedOn > seasonChangeDate) {
              seasonAllowed.push(year.toString());
            }
          }
        }
      } else if (removedYear === null) {
        for (let j = addedYear; j <= currentyear; j++) {
          year = j;
          seasonAllowed.push(year.toString());
        }
      }
    }
    return seasonAllowed;
  };

  const handleSelectAll = (status) => {
    setSelectAll(status);
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    if (status) {
      let businessFarmListValue = businessFarmList;
      let userRegisteredFieldsValue = userRegisteredFields;
      let userSharedFieldsValue = userSharedFields;

      let selectedFarms = [];
      let selectedBusinesses = [];
      let selectedFields = [];
      let selectedIrrigUnitIdsValue = [];
      let validUserSharedField = _.filter(userSharedFieldsValue, {
        rejected: false,
      });
      businessFarmListValue.map((businessFarm) => {
        businessFarm.farms.map((farm) => {
          if (farm.isActive === true) {
            selectedFarms.push(farm.farmName.trim());
          }
        });
        if (businessFarm.isActive === true) {
          selectedBusinesses.push(businessFarm.businessName.trim());
        }
      });

      if (
        (userRegisteredFieldsValue &&
          Object.keys(userRegisteredFieldsValue).length > 0) ||
        (validUserSharedField && Object.keys(validUserSharedField).length > 0)
      ) {
        const allFields =
          userRegisteredFieldsValue.data.fields.concat(validUserSharedField);
        for (let i = 0; i < allFields.length; i++) {
          if (
            selectedBusinesses.includes(allFields[i].business_name.trim()) &&
            selectedFarms.includes(allFields[i].farm_name.trim())
          ) {
            let is_primary_editing = true;
            let secondary_user_id = "N/A";
            let fieldSharedByOtherUser = false;
            let shareFieldEditor = 0;
            let fieldAcres = null;
            let user_email = loggedInUser;
            if (allFields[i].primary_user_id) {
              fieldSharedByOtherUser = true;
              shareFieldEditor = allFields[i].editor;
              secondary_user_id = allFields[i].secondary_user_id;
              is_primary_editing = false;
              user_email = allFields[i].primary_user_email;
            }
            if (allFields[i].hasOwnProperty("primary_user_id")) {
              fieldAcres = allFields[i].irrig_unit_acres;
            } else {
              fieldAcres = allFields[i].acres;
            }
            let acresCurrentYear = getCurrentYearAcres(
              allFields[i].irrig_unit_id
            );
            let currentYearAcres = EMPTY;
            if (acresCurrentYear === false) {
              currentYearAcres = fieldAcres;
            } else {
              currentYearAcres = acresCurrentYear;
            }
            selectedFields.push({
              irrig_unit_id: allFields[i].irrig_unit_id,
              fieldId: allFields[i].user_field_id
                ? allFields[i].user_field_id
                : allFields[i].field_id,
              fieldName: allFields[i].field_name,
              fieldAcres: fieldAcres,
              acresCurrentYear: currentYearAcres,
              fieldFarm: allFields[i].farm_name,
              fieldBusiness: allFields[i].business_name,
              is_primary_editing: is_primary_editing,
              secondary_user_id: secondary_user_id,
              shareFieldEditor: shareFieldEditor,
              fieldSharedByOtherUser: fieldSharedByOtherUser,
              user_email: user_email,
            });

            selectedIrrigUnitIdsValue.push(allFields[i].irrig_unit_id);

            setSelectedFieldsOnPanel(selectedFields);
            setSelectedIrrigUnitIds(selectedIrrigUnitIdsValue);
          }
        }
      }
    } else {
      removeWells();
    }
  };

  const closeAlert = () => {
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
    setSubmitError(false);
  };

  const getGeometry = (usersFields) => {
    if (AllPolygons.hasOwnProperty("features")) {
      let geometry = _.find(AllPolygons.features, (field) => {
        return field.properties.irrig_unit_id === usersFields.irrig_unit_id;
      });
      return geometry;
    } else {
      return null;
    }
  };

  const AddFilteredFields = (allFields, selectedFarms, selectedBusinesses) => {
    const filteredUserFields = [];
    for (let i = 0; i < allFields.length; i++) {
      if (
        selectedBusinesses.includes(allFields[i].business_name.trim()) &&
        selectedFarms.includes(allFields[i].farm_name.trim())
      ) {
        filteredUserFields.push(allFields[i]);
      }
    }
    return filteredUserFields;
  };

  const userRegisteredField = [];
  const renderBusiness = [];
  const selectedBusinesses = [];
  const selectedFarms = [];
  let userFieldCrops = [];
  renderBusiness.push(
    <div key="chkAllFieldsDiv">
      <Form.Check
        key="chkAllFields"
        type="checkbox"
        name="chkDisplayAllFields"
        label="Display all fields"
        id="chkAllFields"
        checked={displayAllField}
        onChange={handleDisplayAllField}
      />
      <b>
        <label style={{ marginleft: "-11px" }}>Businesses</label>
      </b>
    </div>
  );

  businessFarmList.map((businessFarm, index) => {
    let renderFarm = [];
    businessFarm.farms.map((farm, findex) => {
      renderFarm.push(
        <Form.Check
          key={"chkCheckboxid" + farm.farmName}
          name={farm.farmName}
          label={farm.farmName}
          id={"chkCheckboxid" + farm.farmName}
          checked={farm.isActive}
          onChange={toggleFarmCheckbox(index, findex)}
        />
      );
      if (farm.isActive === true) {
        selectedFarms.push(farm.farmName.trim());
      }
    });
    if (businessFarm.isActive === true) {
      selectedBusinesses.push(businessFarm.businessName.trim());
    }
    renderBusiness.push(
      <div key={"divfor" + businessFarm.businessName}>
        <Row className="display-option-row">
          <Form.Group as={Col} md="11" className="mb-0">
            <Form.Check
              key={"chkBusinessId" + businessFarm.businessName}
              name={businessFarm.businessName}
              label={businessFarm.businessName}
              id={"chkBusinessId" + businessFarm.businessName}
              checked={businessFarm.isActive}
              onChange={toggleBusinessCheckbox(index)}
            />
          </Form.Group>
          <Form.Group as={Col} md="1" className="mb-0">
            {businessFarm.isActive ? (
              <i className="fa fa-caret-down"></i>
            ) : (
              <i className="fa fa-caret-right"></i>
            )}
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} md="12" className="mb-0">
            {businessFarm.isActive === true ? (
              <div className="ps-3">{renderFarm}</div>
            ) : (
              EMPTY
            )}
          </Form.Group>
        </Row>
      </div>
    );
  });

  if (
    (userRegisteredFields && Object.keys(userRegisteredFields).length > 0) ||
    userSharedFields.length > 0
  ) {
    const allFields = userRegisteredFields.data.fields.concat(userSharedFields);
    const filteredUserFields = AddFilteredFields(
      allFields,
      selectedFarms,
      selectedBusinesses
    );

    userFieldCrops = UserCropDetails;
    const sortedUsersFields = filteredUserFields.sort(function (a, b) {
      if (a.field_name.toLowerCase() < b.field_name.toLowerCase()) {
        return -1;
      }
      if (a.field_name.toLowerCase() > b.field_name.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    let fieldNames = sortedUsersFields.map((field) => {
      let irrig_unit_id = field.irrig_unit_id;
      let isShared = false;
      if (field.hasOwnProperty("primary_user_id")) {
        isShared = true;
      }
      return {
        fieldName: field.field_name.trim().toLowerCase(),
        irrig_unit_id: irrig_unit_id,
        isShared: isShared,
      };
    });
    for (let j = 0; j < sortedUsersFields.length; j++) {
      const isSharedField = sortedUsersFields[j].hasOwnProperty(
        "primary_user_id"
      )
        ? true
        : false;
      if (
        isSharedField === true &&
        sortedUsersFields[j].hasOwnProperty("rejected") &&
        sortedUsersFields[j].rejected === true
      ) {
        continue;
      }
      const sortedUsersField = sortedUsersFields[j];

      const sharedField = isSharedField ? true : false;
      const shareFieldDetails = isSharedField
        ? {
            field_name: sortedUsersFields[j].field_name,
            business_name: sortedUsersFields[j].business_name,
            farm_name: sortedUsersFields[j].farm_name,
            acres: sortedUsersFields[j].irrig_unit_acres,
            owner_name: `${sortedUsersFields[j].primary_user}`,
            owner_field_name: `${sortedUsersFields[j].primary_field_name}`,
            owner_field_irrig_unit_id: sortedUsersFields[j].irrig_unit_id,
            shared_field_id: sortedUsersFields[j].shared_field_id,
            owner_user_email: `${sortedUsersFields[j].primary_user_email}`,
            secondary_user_id: `${sortedUsersFields[j].secondary_user_id}`,
          }
        : {};

      const sharedFieldInfo = sortedUsersFields[j];
      const validatedYears = isSharedField
        ? getValidatedYears(sharedFieldInfo)
        : [];
      const fieldId = sortedUsersFields[j].user_field_id
        ? sortedUsersFields[j].user_field_id
        : sortedUsersFields[j].field_id;
      const shareFieldId = sortedUsersFields[j].shared_field_id;

      const cropDetails = isSharedField
        ? userFieldCrops.filter(
            (c) =>
              c.user_field_id === fieldId &&
              validatedYears.includes(c.year.toString())
          )
        : userFieldCrops.filter((c) => c.user_field_id === fieldId);

      const irrig_unit_ID = sortedUsersFields[j].irrig_unit_id;
      const selectedField = sortedUsersFields[j].field_name;

      const acres = isSharedField
        ? parseFloat(sortedUsersFields[j].irrig_unit_acres).toFixed(2)
        : parseFloat(sortedUsersFields[j].acres).toFixed(2);
      let crops = [];
      let acresCurrentYear = getCurrentYearAcres(irrig_unit_ID);
      let currentYearAcres = EMPTY;
      if (acresCurrentYear === false) {
        currentYearAcres = acres;
      } else {
        currentYearAcres = acresCurrentYear;
      }
      let is_primary_editing = true;
      let secondary_user_id = "N/A";
      let fieldSharedByOtherUser = false;
      let shareFieldEditor = false;

      let user_email = loggedInUser;
      if (isSharedField) {
        fieldSharedByOtherUser = true;
        shareFieldEditor = sortedUsersFields[j].editor;
        is_primary_editing = false;
        secondary_user_id = sortedUsersFields[j].secondary_user_id;
        user_email = sortedUsersFields[j].primary_user_email;
      }
      const sortedcrops = cropDetails.sort((a, b) => {
        if (a.year < b.year) {
          return -1;
        }
        if (a.year > b.year) {
          return 1;
        }
        if (a.crop.toLowerCase() < b.crop.toLowerCase()) {
          return -1;
        }
        if (a.crop.toLowerCase() > b.crop.toLowerCase()) {
          return 1;
        }

        return 0;
      });
      if (sortedcrops.length === 0) {
        crops.push(
          <li key={"crop0000"}>
            <i>{"No crop added"}</i>
          </li>
        );
      }
      for (let n = 0; n < sortedcrops.length; n++) {
        crops.push(
          <li key={"crop" + n}>
            {`${sortedcrops[n].crop} | ${sortedcrops[n].tillage} (${Number(
              sortedcrops[n].acres
            ).toFixed(2)}) - ${sortedcrops[n].year}`}
          </li>
        );
      }

      const coordinates = sortedUsersFields[j];
      const fillColor1 = isSharedField ? SHAREDFIELD : ADDED;
      const fillColor2 = SELECTED;
      const farmName = sortedUsersFields[j].farm_name;
      const businessName = sortedUsersFields[j].business_name;
      let geomObject = getGeometry(coordinates);
      if (geomObject) {
        coordinates.geometry = geomObject.geometry;
      }
      const paths = GoogleMapHelper.getCoordinates(coordinates);
      const coords = GoogleMapHelper.getPolygonCenter(coordinates);
      userRegisteredField.push(
        <div
          key={`field-${irrig_unit_ID}`}
          className="d-flex align-items-start"
        >
          <Form.Check
            key={"chkFieldId" + selectedField}
            id={"chkFieldId" + selectedField}
            onChange={(e) => {
              props.showFieldOnMAP(
                coords,
                paths,
                irrig_unit_ID,
                fillColor1,
                fillColor2
              );
              handleFieldCheck(
                sortedUsersField,
                irrig_unit_ID,
                fieldId,
                selectedField,
                acres,
                currentYearAcres,
                farmName,
                businessName,
                fieldSharedByOtherUser,
                shareFieldEditor,
                is_primary_editing,
                secondary_user_id,
                user_email
              );
            }}
            checked={selectedIrrigUnitIds.some(
              (irrig_unit_id) => irrig_unit_id === irrig_unit_ID
            )}
          />

          <Accordion.Item
            eventKey={j}
            key={j}
            id={"card_" + irrig_unit_ID}
            className="flex-grow-1 transition-bg"
          >
            <Accordion.Header onClick={collapseAll}>
              <a
                className={`wdp-field-name cursor-pointer ${
                  isSharedField ? "highlight-share-field" : "highlight-field"
                }`}
              >
                {selectedField}
              </a>
            </Accordion.Header>
            <Accordion.Collapse
              eventKey={j}
              id={irrig_unit_ID}
              className={`field_card  ${
                (!props.fieldClicked && props.expand) ||
                (props.fieldClicked && props.selectedField === irrig_unit_ID)
                  ? "show"
                  : "collapse"
              }`}
            >
              <>
                <div className="farmer-panel-fields-icons">
                  <span
                    onClick={(e) => {
                      handdlePanelButtonClick(
                        sortedUsersField,
                        fieldId,
                        cropDetails,
                        acres,
                        irrig_unit_ID,
                        selectedField,
                        sortedUsersField,
                        fieldNames,
                        sharedField,
                        shareFieldDetails,
                        "fieldDetails"
                      );
                    }}
                  >
                    <i className="fa-regular fa-pen-to-square" />
                  </span>
                  <span
                    onClick={(e) => {
                      handdlePanelButtonClick(
                        sortedUsersField,
                        fieldId,
                        cropDetails,
                        acres,
                        irrig_unit_ID,
                        selectedField,
                        sortedUsersField,
                        fieldNames,
                        sharedField,
                        shareFieldDetails,
                        "summary"
                      );
                    }}
                  >
                    <i className="fa-regular fa-eye" />
                  </span>
                  {isSharedField ? (
                    <span
                      onClick={(e) => {
                        handleRejectOrDeleteShareFieldClick(
                          e,
                          shareFieldId,
                          selectedField
                        );
                      }}
                    >
                      <i className="fa-regular fa-trash-can" />
                    </span>
                  ) : (
                    EMPTY
                  )}
                </div>
                <ul>
                  <li>
                    <span className="fw-bold ">Certified Acres:</span> {acres}
                  </li>
                  <li>
                    <span className="fw-bold ">Farm:</span> {farmName}
                  </li>
                  <li>
                    <span className="fw-bold ">Business:</span> {businessName}
                  </li>
                  <li>
                    <span className="fw-bold ">Crops:</span> <ul>{crops}</ul>
                  </li>
                </ul>
              </>
            </Accordion.Collapse>
          </Accordion.Item>
        </div>
      );
    }
  }

  return (
    <aside
      ref={props.panelRef}
      className={`sidebar farmer-panel ${
        !props.showWdpPanel && "hide-sidebar"
      }`}
    >
      <LoadingOverlay
        showSpinner={true}
        active={overlayLoading}
        text="Loading Map..."
      />
      <div className="farmer-panel-filter">
        <Accordion
          onSelect={(key) => setDisplayOptionsKey(key)}
          activeKey={displayOptionsKey}
        >
          <div
            className="hide-panel"
            onClick={() => props.setShowWdpPanel(!props.showWdpPanel)}
          >
            <b className="close">{props.showWdpPanel ? ">" : "<"}</b>
          </div>
          <Accordion.Item eventKey={DISPLAY_FIELD_OPTIONS}>
            <Accordion.Header>Display Options</Accordion.Header>
            <Accordion.Body className="display-option-body">
              {renderBusiness}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <Card className="farmer-panel-fields-card">
        <Card.Header>
          {`Field Details - Selected fields (${selectedFieldsOnPanel.length}) `}
        </Card.Header>
      </Card>
      <div className="text-end mb-2">
        {selectAll === true && (
          <a
            onClick={() => handleSelectAll(false)}
            className="btn btn-secondary"
            title="Deselect All Fields"
          >
            <i className="fa-regular fa-square-check" />
          </a>
        )}
        {selectAll === false && (
          <a
            onClick={() => handleSelectAll(true)}
            className="btn btn-secondary"
            title="Select All Fields"
          >
            <i className="fa-regular fa-square" />
          </a>
        )}
        <a
          onClick={expandAll}
          className="btn btn-secondary"
          title="Show All Field Details"
        >
          <i className="fa fa-expand"></i>
        </a>
        <a
          onClick={collapseAll}
          className="btn btn-secondary"
          title="Hide All Field Details"
        >
          <i className="fa fa-compress"></i>
        </a>
        <a
          onClick={handleShareFields}
          className="btn btn-secondary"
          title="Share Field(s)"
        >
          <i className="fa-solid fa-share-nodes"></i>
        </a>
      </div>
      <div
        className={`farmer-panel-fields ${
          !displayOptionsKey && "farmer-panel-fields-extend"
        } `}
      >
        <Accordion className="mt-2 farmer-panel-fields-accordion">
          {submitError ? (
            <Alert
              key="messageAlert"
              variant={variant}
              closeAlert={(e) => closeAlert(e)}
              alertMessage={alertMessage}
              dismissible
            />
          ) : (
            EMPTY
          )}
          {userRegisteredField}
        </Accordion>
        {showFieldPopup ? (
          <FieldDetailsModal
            acres={fieldAcres}
            cropDetails={fieldCrops}
            closeModal={(e) => closeModal(e)}
            fieldId={fieldId}
            irrig_unit_Id={irrig_unit_Id}
            refreshPanel={(refreshPanelValue) =>
              refreshPanel(refreshPanelValue)
            }
            selectedField={selectedField}
            fieldDetails={fieldDetails}
            fieldNames={fieldNames}
            userClaimedFields={userClaimedFields}
            sharedField={sharedField}
            shareFieldDetails={shareFieldDetails}
            userSharedFields={userSharedFields}
            yearAcresDetails={props.yearAcresDetails}
            defaultModalActiveKey={defaultModalActiveKey}
          />
        ) : (
          EMPTY
        )}
        {shareFieldPopUp ? (
          <ShareFieldPopUp
            selectedFieldsOnPanel={selectedFieldsOnPanel}
            closeModal={(e) => handleCloseShareModal(e)}
            clearAllSelectedFields={(e) => handleClearAllSelectedFields(e)}
          ></ShareFieldPopUp>
        ) : (
          EMPTY
        )}
        {showConfirmPopup && (
          <DeletePopUp
            showConfirmPopup={showConfirmPopup}
            selectedField={selectedField}
            index={0}
            closeWarningPopup={(e) => closeWarningPopup(e)}
            performWarningAction={(e, idx) => performWarningAction(e, idx)}
            header={header}
          />
        )}
      </div>
    </aside>
  );
}

export default WDPPanel;
